import {createAction, props} from '@ngrx/store';
import {Organization, PaginatedOrganization} from '@app/modules/shared/models';

enum EOrganizationActions {
  OrganizationsListAll = '[Organizations] Organizations List All',
  OrganizationsListAllSuccess = '[Organizations] Organizations List All Success',
  OrganizationsListAllError = '[Organizations] Organizations List All Error',
  OrganizationsList = '[Organizations] Organizations List',
  OrganizationsListSuccess = '[Organizations] Organizations List Success',
  OrganizationsListError = '[Organizations] Organizations List Error',
  OrganizationDelete = '[Organizations] Organization Delete',
  OrganizationDeleteSuccess = '[Organizations] Organization Delete Success',
  OrganizationDeleteError = '[Organizations] Organization Delete Error',
  OrganizationUpdate = '[Organizations] Organization Update',
  OrganizationUpdateSuccess = '[Organizations] Organization Update Success',
  OrganizationUpdateError = '[Organizations] Organization Update Error',
  OrganizationAdd = '[Organizations] Organization Add',
  OrganizationAddSuccess = '[Organizations] Organization Add Success',
  OrganizationAddError = '[Organizations] Organization Add Error',
  OrganizationGet = '[Organizations] Organization Get',
  OrganizationGetSuccess = '[Organizations] Organization Get Success',
  OrganizationGetError = '[Organizations] Organization Get Error',

  ResetOrganizationState = '[Organizations] Reset Organization State',
}

export const OrganizationsListAll = createAction(EOrganizationActions.OrganizationsListAll, (params: any = {}) => params);
export const OrganizationsListAllSuccess = createAction(EOrganizationActions.OrganizationsListAllSuccess, props<{ organizations: Organization[] }>());
export const OrganizationsListAllError = createAction(EOrganizationActions.OrganizationsListAllError, props<{ error: string }>());

export const OrganizationsList = createAction(EOrganizationActions.OrganizationsList, (params: any = {}) => params);
export const OrganizationsListSuccess = createAction(EOrganizationActions.OrganizationsListSuccess, props<{ paginatedOrganizations: PaginatedOrganization }>());
export const OrganizationsListError = createAction(EOrganizationActions.OrganizationsListError, props<{ error: string }>());

export const OrganizationDelete = createAction(EOrganizationActions.OrganizationDelete, props<{ organizationId: number }>());
export const OrganizationDeleteSuccess = createAction(EOrganizationActions.OrganizationDeleteSuccess);
export const OrganizationDeleteError = createAction(EOrganizationActions.OrganizationDeleteError, props<{ error: string }>());

export const OrganizationUpdate = createAction(EOrganizationActions.OrganizationUpdate, props<{ organizationId: number; organization: Organization }>());
export const OrganizationUpdateSuccess = createAction(EOrganizationActions.OrganizationUpdateSuccess);
export const OrganizationUpdateError = createAction(EOrganizationActions.OrganizationUpdateError, props<{ error: string }>());

export const OrganizationAdd = createAction(EOrganizationActions.OrganizationAdd, props<{ organization: Organization }>());
export const OrganizationAddSuccess = createAction(EOrganizationActions.OrganizationAddSuccess);
export const OrganizationAddError = createAction(EOrganizationActions.OrganizationAddError, props<{ error: string }>());

export const OrganizationGet = createAction(EOrganizationActions.OrganizationGet, props<{ organizationId: number }>());
export const OrganizationGetSuccess = createAction(EOrganizationActions.OrganizationGetSuccess, props<{ organization: Organization }>());
export const OrganizationGetError = createAction(EOrganizationActions.OrganizationGetError, props<{ error: string }>());

export const ResetOrganizationState = createAction(EOrganizationActions.ResetOrganizationState, (params: any = {}) => params);
